export enum ProductType {
    Fixed = 'Fixed',
    Saron = 'Saron',
    Variable = 'Variable',
    ConstructionCredit = 'ConstructionCredit'
}
